import { Navigate } from "react-router-dom";
import AddEmployeeDocument from "./AddEmployeeDocument";
import GetAllEmployeeDocuments from "./GetAllEmployeeDocuments";
import { Col, Row, Form } from "antd";
import { useState } from "react";
import getUserFromToken from "../../utils/getUserFromToken";

const EmployeeDocuments = ({ mode = "admin" }) => {
	const [form] = Form.useForm();
	const [isEditMode, setIsEditMode] = useState(false);
	const [currentDocumentId, setCurrentDocumentId] = useState(null);
	const loggedInEmployeeId = mode === "user" ? getUserFromToken() : null;

	const isLogged = Boolean(localStorage.getItem("isLogged"));
	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	return (
		<div className="add-employee-document-page-wrapper">
			<Row gutter={16} className="add-employee-document-row">
				{/* Left Side - Generate Employee Document Form */}
				<Col xs={24} sm={24} md={10} lg={8} className="add-employee-document-form-col">
					<AddEmployeeDocument
						form={form}
						isEditMode={isEditMode}
						setIsEditMode={setIsEditMode}
						currentDocumentId={currentDocumentId}
						setCurrentDocumentId={setCurrentDocumentId}
						mode={mode}
						loggedInEmployeeId={loggedInEmployeeId}
					/>
				</Col>

				{/* Right Side - Employee Documents List */}
				<Col xs={24} sm={24} md={14} lg={16} className="add-employee-document-table-col">
					<GetAllEmployeeDocuments
						form={form}
						setIsEditMode={setIsEditMode}
						setCurrentDocumentId={setCurrentDocumentId}
						mode={mode}
						loggedInEmployeeId={loggedInEmployeeId}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default EmployeeDocuments;

